'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from '@/contexts/InAppProvider';
import { SearchPage } from 'app/(main)/search/SearchPage';
import { searchDescription } from 'constants/metadata';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return (
    <>
      <title>검색 | 디리토</title>
      <meta name="description" content={searchDescription} />
      <SearchPage isApp={isApp} />
    </>
  );
}
